import { api } from "./api";
import { normalizeNewsItem } from "../utils/newsUtils";

export async function fetchAllNews() {
  const data = await api.getNews();
  return data.map(normalizeNewsItem);
}

export async function fetchNewsById(id) {
  const item = await api.getNewsItem(id);
  return normalizeNewsItem(item);
}
